import { FrontUrls } from 'Src/constants/FrontUrls'
import React, { lazy } from 'react'
import { LazyRoute } from 'Modules'
import {
	MassUpdateCuratorLazy,
	MatrixRoleLazy,
	MassUseMerchantLazy,
	RegistryListLazy,
	BlackListPartnerLazy,
} from 'Pages/pp'
import { AffiliateProgramReportLazy } from 'Pages/pp/affiliateProgramReports/routes'

const CustomerIdentificationAuthLoginFormLazy = lazy(
	() => import('Src/containers/CustomerIdentification/CustomerIdentificationAuthLoginForm')
)

export const PPRoutes = [
	<LazyRoute
		path={FrontUrls.pp.mass_update_curator_form}
		lazyComponent={MassUpdateCuratorLazy}
		key={FrontUrls.pp.mass_update_curator_form}
	/>,
	<LazyRoute
		path={FrontUrls.pp.customer_identification_auth}
		lazyComponent={CustomerIdentificationAuthLoginFormLazy}
		key={FrontUrls.pp.customer_identification_auth}
	/>,
	<LazyRoute
		exact
		path={FrontUrls.pp.matrix_role}
		lazyComponent={MatrixRoleLazy}
		key={FrontUrls.pp.matrix_role}
	/>,
	<LazyRoute
		exact
		path={FrontUrls.pp.mass_use_merchant_form}
		lazyComponent={MassUseMerchantLazy}
		key={FrontUrls.pp.mass_use_merchant_form}
	/>,
	<LazyRoute
		path={FrontUrls.pp.contracts_registry}
		lazyComponent={RegistryListLazy}
		key={FrontUrls.pp.contracts_registry}
	/>,
	<LazyRoute
		path={FrontUrls.pp.black_list_partner}
		lazyComponent={BlackListPartnerLazy}
		key={FrontUrls.pp.contracts_registry}
	/>,
	<LazyRoute
		path={FrontUrls.pp.affiliate_program_reports}
		lazyComponent={AffiliateProgramReportLazy}
		key={FrontUrls.pp.affiliate_program_reports}
	/>,
]
